export default "__VITE_ASSET__C6pt2A_c__"